import { makeIconDef } from "./makeIconDef";

export const MinusIconDef = {
  minus: makeIconDef('minus', {
    regular: () => <path d="M4 12H20" stroke="currentColor" />,
    filled: () => <path d="M4 12H20" stroke="currentColor" strokeWidth="2" />,
  })
}